import { getStoredUser } from './authentication';

export const isDentistUser = (user) =>
  String(user?.user_type_name ?? user?.userType?.name ?? '').toLowerCase() === 'dentist';

export const getDentistClientId = (user) => {
  const resolved = user ?? getStoredUser();
  const clientId = resolved?.client_id;
  return clientId != null && clientId !== '' ? Number(clientId) : null;
};

/** Sub client-portal account (clinic/hospital only; lab contacts are never sub). */
export const isSubClientAccount = (user) => {
  const resolved = user ?? getStoredUser();
  if (!isDentistUser(resolved)) {
    return false;
  }
  const role = String(resolved?.client_account_role ?? 'main').trim().toLowerCase();
  if (role !== 'sub') {
    return false;
  }
  const clientType = String(resolved?.client?.type ?? '').trim().toLowerCase();
  return clientType !== 'lab';
};

/** Menu pages hidden for dentist portal users (catalog/admin views). */
export const DENTIST_HIDDEN_MENU_PAGES = new Set([
  'colors',
  'formula_types',
  'platform_settings',
  'delivery_centers',
  'wallets',
  'clients',
  'dentists',
  'setting',
  'finance',
]);

/** Extra menu pages hidden for sub client accounts (orders-only). */
export const SUB_ACCOUNT_HIDDEN_MENU_PAGES = new Set([
  'dashboard',
  'invoices',
  'client_settings',
  'client_transactions',
  'client_statement',
  'client_wallet',
]);

/** Menu pages hidden for non-dentist vendor users. */
export const VENDOR_HIDDEN_MENU_PAGES = new Set([
  'client_settings',
  'client_transactions',
  'client_statement',
  'client_wallet',
]);

/** Extra menu pages hidden for technician users. */
export const TECHNICIAN_HIDDEN_MENU_PAGES = new Set();

/** URL prefixes dentists cannot browse (see DentistPortalGuard). */
export const DENTIST_BLOCKED_PATH_PREFIXES = [
  '/clients',
  '/delivery-centers',
  '/wallets',
  '/dentists',
  '/colors',
  '/formula-types',
  '/platform-settings',
];

/** URL prefixes sub accounts cannot browse (redirect to /orders). */
export const SUB_ACCOUNT_BLOCKED_PATH_PREFIXES = [
  '/home',
  '/dashboard',
  '/invoices',
  '/invoice',
  '/client-settings',
  '/client-transactions',
  '/client-statement',
  '/client-wallet',
];

export const SUB_ACCOUNT_HOME_PATH = '/orders';

export const isSubAccountBlockedPath = (pathname) => {
  const path = String(pathname || '').replace(/\/$/, '').toLowerCase() || '/';
  if (path === '/' || path === '') {
    return true;
  }
  return SUB_ACCOUNT_BLOCKED_PATH_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`)
  );
};
